import type { TagDesignTokens, TagTokenSections } from '@openng/optimus-ui-themes/types/tag';

export const root: TagTokenSections.Root = {
	fontSize: '0.75rem',
	fontWeight: '500',
	roundedBorderRadius: '50rem',
};

export const colorScheme: TagTokenSections.ColorScheme = {
	light: {
		primary: {
			background: '{named.tag.primary.background}',
			color: '{surface.800}',
		},
		secondary: {
			background: '{primary.50}',
			color: '{primary.500}',
		},
		success: {
			background: '{green.50}',
			color: '{feedback.success.strong.color}',
		},
		info: {
			background: '{surface.100}',
			color: '{surface.700}',
		},
		warn: {
			background: '{yellow.50}',
			color: '{feedback.warn.strong.color}',
		},
		danger: {
			background: '{red.50}',
			color: '{feedback.danger.strong.color}',
		},
		contrast: {
			background: '{primary.500}',
		},
	},
};

export default {
	root,
	colorScheme,
} satisfies TagDesignTokens;
